var map = {
	"./peixuan2025sar/contours.png": 4399,
	"./peixuan2025sar/formula.png": 5490,
	"./peixuan2025sar/table.png": 5494,
	"./peixuan2025tomap/main_fig.png": 9659,
	"./yao2024deft/DeFT_overview.jpg": 5855,
	"./yao2024deft/deft.jpeg": 6073,
	"./yu2024researchtown/researchtown.png": 4292
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 852;